<template>
	<v-navigation-drawer v-model="open" temporary :width="260" :color="color" class="nav-rail nav-rail--expanded">
		<div class="nav-rail__header">
			<v-btn icon variant="text" size="small" class="nav-rail__toggle" :title="t('NavMenu')" :aria-label="t('NavMenu')" @click="open = false">
				<v-icon>menu_open</v-icon>
			</v-btn>
			<button type="button" class="nav-rail__logo" :title="t('Portal')" @click="emit('portal')">
				<img src="/m.eagle/img/portal/logo-white.png" alt="eCOS" />
			</button>
			<span class="nav-rail__version">{{ version }}</span>
		</div>
		<NavMenuList :menu="menu" :active-view="activeView" @select="select" />
	</v-navigation-drawer>
</template>

<script setup>
import NavMenuList from './NavMenuList.vue';
import { useTranslator } from '@/composables/useTranslator';

defineProps({
	menu: { type: Object, required: true },
	activeView: { type: String, default: null },
	version: { type: String, default: '' },
	color: { type: String, default: 'primary' },
});
const emit = defineEmits(['select', 'portal']);
const open = defineModel({ type: Boolean, default: false });

const t = useTranslator();

const select = (item) => {
	open.value = false;
	emit('select', item);
};
</script>
